export default __webpack_public_path__ + "static/char-s-07-chs-96837e8f48ee77fa3158e09c015ddac8.png";